import { render, staticRenderFns } from "./AppointResponsible.vue?vue&type=template&id=3d3553db"
import script from "./AppointResponsible.vue?vue&type=script&lang=ts"
export * from "./AppointResponsible.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports